export default __webpack_public_path__ + "static/media/kipIcon.ae2a4e63.png";